(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("prop-types"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["prop-types", "react"], factory);
	else if(typeof exports === 'object')
		exports["@transferwise/comparison-components/social-sharing"] = factory(require("prop-types"), require("react"));
	else
		root["@transferwise/comparison-components/social-sharing"] = factory(root["PropTypes"], root["React"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__886__, __WEBPACK_EXTERNAL_MODULE__119__) {
return 